import { jsx } from "react/jsx-runtime";
import { COUNTRY_CODES } from "@wix/form-multiline-address";
import { useMemo } from "react";
import { useConfig } from "../../../contexts/config-context.js";
import { useTranslation } from "../../../contexts/translation-context.js";
import { useAddressLabel } from "../../../hooks/use-address-label.js";
import { createOption } from "../../../ui/autocomplete/autocomplete-wut.js";
import { DropdownAutocompleteWUT } from "../../../ui/dropdown-autocomplete/dropdown-autocomplete-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const MlaCountryWUT = ({
  options,
  onChange,
  ...rest
}) => {
  const { t } = useTranslation();
  const { language } = useConfig();
  const label = useAddressLabel("country");
  const fieldType = FIELD_TYPES.MLA_COUNTRY;
  const countryOptions = useMemo(
    () => (options || []).reduce((result, option) => {
      if (option.value && COUNTRY_CODES.hasOwnProperty(option.value)) {
        result.push(
          createOption({
            value: t(
              `locale-dataset.countries.${COUNTRY_CODES[option.value].toUpperCase()}`
            ),
            id: option.value
          })
        );
      }
      return result;
    }, []).sort((a, b) => a.value.localeCompare(b.value, language)),
    [options, t, language]
  );
  return /* @__PURE__ */ jsx(
    DropdownAutocompleteWUT,
    {
      ...rest,
      fieldType,
      label,
      options: countryOptions,
      onChange: (value) => onChange(value)
    }
  );
};
export {
  MlaCountryWUT
};
//# sourceMappingURL=mla-country-wut.js.map
